import React, {Component} from 'react';
import PropTypes from 'prop-types';
import NavigationLink from '../NavigationLink/NavigationLink';
import {NavLink, Link} from 'react-router-dom';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage, ApiRequest } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class ClientNavigationAdmin extends Component {
    constructor(props) {
		super(props);
		this.state = {
            dashboard: {
                event: '',
                donation: '',
            },
            isAccountingOpen: false,
		}
    }

    componentDidMount() {
        this.getStripeURL();
    }

    componentWillReceiveProps() {
        this.getStripeURL();
    }

    getStripeURL = async () => {
        try {
            const accountsResponse = await getAccounts();
            console.log('accountsResponse: ', accountsResponse);
            this.setState({
                stripe_accounts: accountsResponse.data.stripe_accounts
            } , () => {
                this.getDashboards();
            });
        } catch (error) {
            console.log(error);
        }

		async function getAccounts() {
			return await ApiRequest(`/clients/current/stripe-accounts`, {
                method: 'GET'
            });
        }
    }

    getDashboards = () => {
        let stripe_accounts = this.state.stripe_accounts;
        const getDashboard = async () => {
			try {
                for (let account of stripe_accounts) {
                    if (account.type === 'connect') {
                        let eventResponse = await regular();
                        console.log('eventResponse: ', eventResponse);
                        account.dashboard = eventResponse.data.url;
                    }
                    
                    if (account.type === 'connect-alt') {
                        let donationResponse = await donation();
                        console.log('donationResponse: ', donationResponse);
                        account.dashboard = donationResponse.data.url;
                    }
                }

                console.log('stripe_accounts', stripe_accounts)
                this.setState({
                    stripe_accounts,
                });

			} catch (error) {
				console.log(error);
			}
		};

		async function regular() {
			return await ApiRequest(`/stripe/dashboard/url?type=connect`, {
                method: "GET"
            });
        }
        
        async function donation() {
			return await ApiRequest(`/stripe/dashboard/url?type=connect-alt`, {
                method: "GET"
            });
		}
		getDashboard();
    }

    getStripeDashboards = () => {
        const stripe_accounts = this.state.stripe_accounts;
        let hasEvent = false;
        let event;
        let hasDonation = false;
        let donation;
        if (stripe_accounts) {
            stripe_accounts.forEach((account) => {
                if (account.type === 'connect' && account.dashboard !== '') {
                    hasEvent = true;
                    event = account;
                }
                if (account.type === 'connect-alt' && account.dashboard !== '') {
                    hasDonation = true;
                    donation = account;
                }
            });

            if (hasEvent && !hasDonation) {
                return (
                    <React.Fragment>
                        <li className="showtix-navigation__item">
                            <a
                                className="showtix-navigation__link"
                                href={event.dashboard}
                                target="_blank"
                            >
                                {strings.accountDashboard}
                            </a>
                        </li>
                        <li className="showtix-navigation__item">
                            <button className="showtix-navigation__link"
                                onClick={this.getEventHistory}
                            >
                                {strings.eventHistory}
                            </button>
                        </li>
                        <li className="showtix-navigation__item">
                            <button className="showtix-navigation__link"
                                onClick={this.getDonationsReport}
                            >
                                {strings.donationReport}
                            </button>
                        </li>
                    </React.Fragment>
                    
                );
            }
    
            if (hasEvent && hasDonation) {
                return (
                    <React.Fragment>
                        <li className="showtix-navigation__item">
                            <a
                                className="showtix-navigation__link"
                                href={event.dashboard}
                                target="_blank"
                            >
                                {strings.eventAccountDashboard}
                            </a>
                        </li>
                        <li className="showtix-navigation__item">
                            <button className="showtix-navigation__link"
                                onClick={this.getEventHistory}
                            >
                                {strings.eventHistory}
                            </button>
                        </li>
                        <li className="showtix-navigation__item">
                            <a
                            className="showtix-navigation__link"
                            href={donation.dashboard}
                            target="_blank"
                        >
                            {strings.donationAccountDashboard}
                        </a>
                        <li className="showtix-navigation__item">
                            <button className="showtix-navigation__link"
                                onClick={this.getDonationsReport}
                            >
                                {strings.donationReport}
                            </button>
                        </li>
                    </li>
                    </React.Fragment>
                );
            }
    
            if (!hasEvent && !hasDonation) {
                return (
                    <React.Fragment>
                        <li className="showtix-navigation__item">
                            <button className="showtix-navigation__link"
                                onClick={this.getEventHistory}
                            >
                                {strings.eventHistory}
                            </button>
                        </li>
                        <li className="showtix-navigation__item">
                            <button className="showtix-navigation__link"
                                onClick={this.getDonationsReport}
                            >
                                {strings.donationReport}
                            </button>
                        </li>
                    </React.Fragment>
                    
                );
            }
        }
    }

    getStripeDevices = () => {
        const stripe_accounts = this.state.stripe_accounts;
        let hasEvent = false;
        let event;
        let hasDonation = false;
        let donation;
        if (stripe_accounts) {
            stripe_accounts.forEach((account) => {
                if (account.type === 'connect' && account.dashboard !== '') {
                    hasEvent = true;
                    event = account;
                }
                if (account.type === 'connect-alt' && account.dashboard !== '') {
                    hasDonation = true;
                    donation = account;
                }
            });

            let navigationLink = {
                "title": "POS Terminal",
                "url": "/stripe-devices",
                "subLinks": []
            }

            if (hasEvent || hasDonation) {
                return (
                    <React.Fragment>
                        <NavigationLink
                            navigationLink={navigationLink}
                            toggleNav={this.props.toggleNav} />
                    </React.Fragment>
                    
                );
            }
        }
    }

    getPatronList = () => {
        const getPatronList = async () => {
			try {
				const patronListResponse = await patronList();
                console.log('patronListResponse: ', patronListResponse);
                
                const csvString = patronListResponse.data;
                var a = window.document.createElement('a');
                a.setAttribute('href', 'data:text/csv; charset=utf-8,' + encodeURIComponent(csvString));
                a.setAttribute('download', 'patron_list.csv');
                a.click();

			} catch (error) {
				console.log(error);
			}
		};

		async function patronList() {
			return await ApiRequest(`/reports/patron-list/csv`, {
                method: "GET"
            });
		}
		getPatronList();
    }

    getDonationsReportLegacy = () => {
        window.open(`${process.env.REACT_APP_SHOWTIX4U_API_HOST}/reports/account-history/pdf`);
    }

    getTaxReport = () => {
        const year = 2022;//new Date().getFullYear();
        window.open(`${process.env.REACT_APP_SHOWTIX4U_API_HOST}/reports/tax-data/csv?year=${year}`);
    }

    getEventHistory = () => {
        window.open(`${process.env.REACT_APP_SHOWTIX4U_API_HOST}/reports/event-account-history/csv`);
    }

    getDonationsReport = () => {
        window.open(`${process.env.REACT_APP_SHOWTIX4U_API_HOST}/reports/donation-account-history/csv`);
    }


    /* getAccountHistory = () => {
        const getAccountHistory = async () => {
			try {
				const accountHistoryResponse = await accountHistory();
                console.log('accountHistoryResponse: ', accountHistoryResponse);
                
                const pdfURL = accountHistoryResponse.request.responseURL;
                window.open(pdfURL);
                this.setMessage('','','');

			} catch (error) {
				console.log(error);
			}
		};

		async function accountHistory() {
			return await ApiRequest(`/reports/account-history/pdf`, {
                method: "GET"
            });
		}
		getAccountHistory();
    } */

    getTaxReport = () => {
        const getTaxReport = async () => {
			try {
                const year = 2022;//new Date().getFullYear();
				const taxReportResponse = await taxReport(year);
                console.log('taxReportResponse: ', taxReportResponse);
                
                const csvString = taxReportResponse.data;
                var a = window.document.createElement('a');
                a.setAttribute('href', 'data:text/csv; charset=utf-8,' + encodeURIComponent(csvString));
                a.setAttribute('download', 'patron_list.csv');
                a.click();

			} catch (error) {
				console.log(error);
			}
		};

		async function taxReport(year) {
			return await ApiRequest(`/reports/tax-data/csv?year=${year}`, {
                method: "GET"
            });
		}
		getTaxReport();
    }

    toggleSubnav = () => {
        this.setState({
            isAccountingOpen: !this.state.isAccountingOpen,
        });
    }
    
    render() {
        let accountBalanceLink = {
            title: `${strings.balances}`,
            url: "/account-balance",
            subLinks: []
        }
        return (
            <div className="showtix-navigation__client">
                <div className="showtix-badge showtix-background__grey-3">
                    {strings.title}
                </div>
                <ul className="showtix-navigation__list">
                    {strings.navigationLinks.map((navigationLink, i) =>
                        <NavigationLink
                            key={i}
                            navigationLink={navigationLink}
                            toggleNav={this.props.toggleNav} />
                    )}
                    <li className="showtix-navigation__item">
                        <NavLink
                            className={"showtix-navigation__link title" + (this.state.isAccountingOpen ? ' is-open' : '')}
                            to="#"
                            onClick={() => this.toggleSubnav()}
                        >
                            {strings.accounting}
                        </NavLink>
                        
                        <ul className={"showtix-navigation__sublist " + (this.state.isAccountingOpen ? 'is-open' : '')}>
                            {/* this.getStripeDashboards() */}
                            <li className="showtix-navigation__item">
                                <NavigationLink
                                    navigationLink={accountBalanceLink}
                                    toggleNav={this.props.toggleNav}
                                />
                            </li>
                            <li className="showtix-navigation__item">
                                <button className="showtix-navigation__link"
                                    onClick={this.getDonationsReport}
                                >
                                    {strings.donationReport}
                                </button>
                            </li>
                            <li className="showtix-navigation__item">
                                <button className="showtix-navigation__link"
                                    onClick={this.getDonationsReportLegacy}
                                >
                                    {strings.donationReportLegacy}
                                </button>
                            </li>
                            <li className="showtix-navigation__item">
                                <button className="showtix-navigation__link"
                                    onClick={this.getPatronList}>
                                    {strings.patron}
                                </button>
                            </li>
                            <li className="showtix-navigation__item">
                                <button className="showtix-navigation__link"
                                    onClick={this.getTaxReport}>
                                    {strings.taxReport}
                                </button>
                            </li>
                        </ul>
                    </li>
                    {strings.navigationLinksAfter.map((navigationLink, i) =>
                        <React.Fragment>
                            <NavigationLink
                                key={i}
                                navigationLink={navigationLink}
                                toggleNav={this.props.toggleNav} />
                        </React.Fragment>
                    )}
                    {/* this.getStripeDevices() */}
                </ul>
            </div>
        );
    }
}

ClientNavigationAdmin.propTypes = {
    toggleNav: PropTypes.func
}

export default ClientNavigationAdmin;



// WEBPACK FOOTER //
// ./src/components/Navigation/ClientNavigationAdmin/ClientNavigationAdmin.js